import React from "react";
import { Button } from "../ui/Button";

interface NavbarProps {
  onCtaClick: () => void;
}

export function Navbar({ onCtaClick }: NavbarProps) {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 h-20 bg-[#f5f0e8] border-b border-b-[#a79c68]/30">
      <div className="max-w-5xl mx-auto px-6 sm:px-8 h-full flex items-center justify-between">
        {/* Brand */}
        <img
          src="/images/logo.png"
          alt="Bossenberg"
          className="h-14"
        />
        {/* CTA */}
        <Button variant="primary" size="sm" onClick={onCtaClick}>
          Get a Quote
        </Button>
      </div>
    </nav>
  );
}
